/* FeedbackRow.css — SCOPED to .ccv2-fbk (no global styles.css bleed).
   Reproduced from the old .feedback-panel / .feedback-btn / .feedback-btn-text.

   🔴 BUNDLE E — THIS FILE NOW DRESSES TWO SURFACES, AND THAT IS THE POINT.
   Citations' result cards (screens/MagicCite/FeedbackRow.jsx) and Clark's answers
   (screens/Clark/answer/parts.jsx → AnswerActions) both render these class names and both import
   this stylesheet. The runbook asked for Clark's feedback row to be "1:1 with Citations"; a second
   copy of these rules would have been 1:1 on the day it was written and drifting from the next
   edit. One file means the two cannot disagree — Lane 3's change below is the proof: it was one
   declaration and it landed on both surfaces at once.

   The two components stay separate because they genuinely differ: different endpoints
   (/api/feedback vs /api/clark/feedback), different payloads, and a different noun in the
   question. Presentation is shared; behaviour is not. */

.ccv2-fbk {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--cc-border-soft, #ececea);
  font-family: var(--cc-font-body, "DM Sans", system-ui, sans-serif);
}
.ccv2-fbk-top { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.ccv2-fbk-prompt { font-size: 0.8125rem; color: var(--cc-text-secondary, #5a5a55); }
.ccv2-fbk-actions { display: inline-flex; gap: 6px; }

.ccv2-fbk-btn {
  width: 26px; height: 26px;
  display: inline-flex; align-items: center; justify-content: center;
  background: transparent;
  /* RUN GE - --cc-border-soft aliases `hairline` too (same value as --cc-border, not a softer one),
     so this thumb button's only edge measured 1.47-1.70:1. --cc-edge is the control-boundary role. */
  border: 0.5px solid var(--cc-edge, #ececea);
  border-radius: 5px;
  color: var(--cc-text-secondary, #5a5a55);
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s, background 0.12s;
}
.ccv2-fbk-btn:hover:not(:disabled),
.ccv2-fbk-btn.selected { color: var(--cc-accent-text); border-color: var(--cc-accent-fill); background: var(--cc-bg-card, #fff); }
.ccv2-fbk-btn:disabled { cursor: default; opacity: 0.85; }

.ccv2-fbk-report {
  height: 26px; padding: 0 12px;
  background: transparent;
  border: 0.5px solid var(--cc-edge, #ececea);   /* RUN GE - see .ccv2-fbk-btn above */
  border-radius: 5px;
  color: var(--cc-text-secondary, #5a5a55);
  font-size: 11px;
  font-family: inherit;
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s, background 0.12s;
}
.ccv2-fbk-report:hover:not(:disabled),
.ccv2-fbk-report.active { color: var(--cc-accent-text); border-color: var(--cc-accent-fill); background: var(--cc-bg-card, #fff); }
.ccv2-fbk-report:disabled { cursor: default; opacity: 0.85; }

/* Report reason box */
.ccv2-fbk-reportbox { display: flex; flex-direction: column; gap: 8px; margin-top: 10px; }
.ccv2-fbk-reason {
  width: 100%;
  padding: 8px 10px;
  font-family: inherit;
  font-size: 13px;
  color: var(--cc-text-primary, #0a0a0a);
  background: var(--cc-bg-input, #fff);
  border: 1px solid var(--cc-border, #e7e3da);
  border-radius: 8px;
  resize: vertical;
}
.ccv2-fbk-reason:focus { outline: none; border-color: var(--cc-focus-ring-color); box-shadow: 0 0 0 3px var(--cc-focus-ring); }
/* 🔴 BUNDLE E · LANE 3 — THE ONE CHANGE OWED TO CITATIONS. `Send report` was left-aligned under
   a full-width textarea, which reads as the start of another row rather than as the action that
   closes the one above it. Centred, it belongs to the box it sits beneath. This is also the only
   place the two surfaces were specified to differ, so centring it here makes them identical. */
.ccv2-fbk-report-send {
  align-self: center;
  height: 28px; padding: 0 14px;
  font-size: 13px; font-weight: 600;
  color: var(--cc-on-accent); background: var(--cc-accent-fill);
  border: none; border-radius: 999px; cursor: pointer;
}
.ccv2-fbk-report-send:hover:not(:disabled) { filter: brightness(1.06); }
.ccv2-fbk-report-send:disabled { cursor: default; opacity: 0.7; }

/* 🔴 BUNDLE E · LANE 6 — A VISIBLE FOCUS RING, WHICH NEITHER SURFACE HAD.
   The thumbs, Report and Send report were keyboard-reachable and keyboard-operable but showed
   nothing when focused: the browser default ring is suppressed by the `border` + `background`
   these carry, so tabbing through a result card or an answer moved an invisible cursor. Found by
   auditing the rule set rather than by tabbing, and it was missing on BOTH surfaces — so this one
   declaration set is the second thing this file fixes in two places at once. */
.ccv2-fbk-btn:focus-visible,
.ccv2-fbk-report:focus-visible,
.ccv2-fbk-report-send:focus-visible {
  outline: 2px solid var(--cc-focus-ring-color);
  outline-offset: 2px;
}

.ccv2-fbk-error { margin: 8px 0 0; font-size: 0.8125rem; color: var(--cc-error-text, #b91c1c); }

/* Thanks state */
.ccv2-fbk--thanks { display: flex; align-items: center; }
.ccv2-fbk-thanks-text { font-size: 0.8125rem; color: var(--cc-text-secondary, #5a5a55); }
